import { useLocale } from '@ecomm/data-hooks'
import { NativeVideo } from '@ecomm/shared-components/lib/NativeVideo'
import type { TypeOf } from '@simplisafe/ewok'
import type { videoSchema } from './schema'

// video data should be correctly passed from monitoring page ctfl entry
// keeping the heading/subtitle hardcoded for now as it was before. Could change if preferred.

type VideoSection = TypeOf<typeof videoSchema>
/**
 * @deprecated use VideoSection from shared-component instead
 */
export function VideoSection({
  posterImage,
  captions,
  mp4Link,
  webmLink
}: VideoSection) {
  const locale = useLocale()

  const heading =
    locale === 'en-US'
      ? 'How we help prevent crime'
      : 'See how we keep you safe'
  const subtitle =
    locale === 'en-US'
      ? 'Today, most traditional home security systems will trigger an alarm when an intruder is breaking into your home, but by then it may be too late. Now, you can feel safer than ever with SimpliSafe® Active Guard Outdoor Protection — our AI-powered Outdoor Camera works with live agents to proactively deter intruders outside your home.'
      : 'Only SimpliSafe® agents can see and speak to intruders via an indoor camera during an alarm'

  return (
    <div className="flex flex-col items-center">
      <h2 className="mb-4 md:mb-6 text-center">{heading}</h2>
      <p className="mx-2 mb-2 text-center md:mx-4 md:mb-4 lg:mb-6">
        {subtitle}
      </p>
      <NativeVideo
        autoPlay={false}
        captionsSrcUrl={captions}
        className="h-auto"
        containerClassName="mx-auto max-w-5xl"
        data-component="monitoring-video"
        data-testid="monitoring-video"
        muted={false}
        poster={posterImage ?? ''}
        preload="none"
        videoSrcUrlMp4={mp4Link}
        videoSrcUrlWebm={webmLink}
      />
    </div>
  )
}
